import { format as dateFormat } from 'date-fns';
import { isArray, isString } from 'lodash';
import { getPluralFormNameForCardinalByLocale as getPluralName } from 'fast-plural-rules';
import * as dateFnsLocales from 'date-fns/locale';
import { ymdToDate } from '@/util';

export const tlMixin = {
    methods: {
        $L(tlKey, args) {
            const { strings } = this.$store.getters.locale;
            const initialString = strings[tlKey];
            if (initialString == null)
                return tlKey;
            
            return initialString.replace(formatStringReplacer, (_, idx, extra) => {
                if (args == null)
                    return '(NO_ARGS)';
        
                const value = args[idx];
                if (value == null)
                    return '(NULL_ARG)';
        
                if (extra == null)
                    return value;
                
                if (extra.startsWith('!')) {
                    const fmtFlag = extra.substr(1);
                    if (!Object.prototype.hasOwnProperty.call(flags, fmtFlag))
                        return '(MISSING_FLAG)';

                    const selector = flags[fmtFlag];
                    return selector(value, this);
                } 

                return this.$LFormat(extra, value);
            });
        },

        $LFormat(fmtKey, value) {
            const {format, dateFnsLocaleKey} = this.$store.getters.locale;
            if (!Object.prototype.hasOwnProperty.call(format, fmtKey))
                return '(MISSING_FMT_STRING)';

            if (!Object.prototype.hasOwnProperty.call(formatters, fmtKey))
                return '(MISSING_FORMATTER)';

            const formatter = formatters[fmtKey];
            return formatter(value, format[fmtKey], { locale: dateFnsLocales[dateFnsLocaleKey] });
        },

        $LPluralize(source, value) {
            const {plurals, locale} = this.$store.getters.locale;
            if (isString(source)) {
                if ((source = plurals[source]) == null)
                    return '(MISSING_BUILTIN_PLURAL)';
            }

            const name = getPluralName(locale, value);
            const form = source[name];
            if (form == null)
                return '(MISSING_PLURAL_FORM)';

            return form;
        },
    },
};

export const tlDirective = (function() {
    return {
        mounted(el, {arg, value, instance}) {
            instance.$$unwatch = instance.$watch(
                () => instance.$store.state.options.localeKey,
                () => updated(el, {arg, value, instance}),
                { immediate: true }
            );
        },
        unmounted(_, {instance}) {
            if (instance.$$unwatch != null)
                instance.$$unwatch();
            delete instance.$$unwatch;
        },
        updated,
    };

    function updated(el, {arg, value, instance}) {
        const tlKey = arg ?? 'TL_ERROR_MISSING_KEY';
        if (value == null);
        else if (!isArray(value))
            value = [value];
    
        el.textContent = instance.$L(tlKey, value);
    }
}());

const formatStringReplacer = /\{(\d+)(?::([!\w]+))?\}/gu;

const flags = {
    DATE_PREFER_NO_YEAR(value, { $today, $LFormat }) {
        value = ymdToDate(value);
        const fmtStr = $today.getFullYear() === value.getFullYear()
            ? 'DATE_SHORT'
            : 'DATE_SHORT_WITH_YEAR';

        return $LFormat(fmtStr, value);
    },

    UNIT_CARDINAL({num, source}, {$LPluralize, $store}) {
        if (source != null && source !== '') {
            const { unitFormat } = $store.getters.locale;
            source = source.match(new RegExp(unitFormat, 'u')).groups;
        }

        // don't use nullish coalescing here
        return $LPluralize(source || 'UNIT', num);
    },

    DAY_CARDINAL({num}, {$LPluralize}) {
        return $LPluralize('DAY', num);
    },
};

const formatters = {
    DATE_SHORT(value, fmtStr, options) {
        return dateFormat(ymdToDate(value), fmtStr, options);
    },

    DATE_SHORT_WITH_YEAR(value, fmtStr, options) {
        return dateFormat(ymdToDate(value), fmtStr, options);
    },

    TIME(value, fmtStr, options) {
        return dateFormat(value, fmtStr, options);
    },
};